import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import UiSelect from "../../common/UiSelect";
import withContext from "../../../tools/withContext";
import constants from "../../../tools/constants";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing.unit * 2,
    },
  });

interface PropTypes {
  tagListId: string;
  ctx: any;
  onChange: any;
  classes: any;
  value: any;
  disabled: boolean;
  tagLists: any[];
  setTagsList: any;
}

interface TagType {
  id: string;
  name: string;
}

const TagList = (props: PropTypes) => {
  const {
    ctx: { appFetch },
    onChange,
    value,
    tagLists,
    disabled,
    setTagsList,
  } = props;
  const [tags, setTags] = useState<any>({});

  useEffect(() => {
    let newTags: any = {};
    tagLists.forEach((t) => {
      newTags[t.id] = t.tagDtos;
    });
    setTags(newTags);
    setTagsList(newTags);
  }, []);

  return (
    <>
      <UiSelect
        name="tagListId"
        required
        disabled={disabled}
        value={value}
        onChange={onChange}
        label=""
      >
        <option value="">Aucune liste sélectionnée</option>
        {Object.keys(tags).length > 0 &&
          tagLists.map((tag: any) => (
            <option key={tag.id} value={tag.id} title={tags[tag.id].join(", ")}>
              {tag.name}
            </option>
          ))}
      </UiSelect>
    </>
  );
};

export default withContext(withStyles(styles)(TagList));
